import { styled } from '../../styles';

export const StyledTypography = {
  Body1: styled('p', {
    fontSize: '16px',
    lineHeight: '22px',
    margin: 0,
    fontFamily: 'sans-serif',
    color: '$neutralVeryDark',
  }),
  Subtitle2: styled('p', {
    fontSize: '14px',
    lineHeight: '18px',
    margin: 0,
    fontFamily: 'sans-serif',
    fontWeight: 500,
    color: '$neutralVeryDark',
  }),
};